/***********************************************
* LandingPage.js
* 
* Show a landingpage
***********************************************/
/* Layout files */
import '../assets/style/NewLandingPage.css';

/* Global imports */
import React   from 'react';
import { withTranslation } from 'react-i18next';

class NewLandingPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render() {

        return (
            <div className="landing">
                <div className="loginMarkdownDiv">
                    <select name="language" id="language" className="languageSelect" value={this.props.language.active} onChange={(e) => this.props.language.set(e.target.value)}>
                        {this.props.language.list.map((lang) => <option key={lang} value={lang}>{lang}</option>)}
                    </select>
                </div>
                <div className='landingContentPage'>
                    <img src="logo_top.jpg" alt="Logo" />
                </div>
            </div>
        );
    }
}

export default withTranslation("Landingpage")(NewLandingPage);